module.exports = __webpack_public_path__ + "static/img/404.ee664250.svg";